import { Typography } from "@mui/material";
import React from "react";

const Title = ({ title }) => {
  return (
    <Typography
      sx={{
        fontWeight: "600",
        fontSize: "24px",
        lineHeight: "10px",
        textAlign: "center",
      }}
      className="text-textColor dark:text-darkTextColor"
    >
      {title}
    </Typography>
  );
};

export default Title;
